import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: 'auto',
    marginBottom: 'auto',
    cursor: 'pointer'
  },
  checkboxLabel: {
    position: 'static',
    cursor: 'pointer'
  },
  selectAll: {
    fontSize: 14,
    fontWeight: 600,
    color: GRAY_COLORS[500],
    cursor: 'pointer',
    textDecoration: 'underline'
  }
}))
